
namespace TabAurous.ECommerce {

    import fld = OrderProcessingRow.Fields;
    @Serenity.Decorators.registerClass()
    export class OrderProcessingGrid extends _Ext.GridBase<OrderProcessingRow, any> {
        protected getColumnsKey() { return 'ECommerce.OrderProcessing'; }
        protected getDialogType() { return OrderProcessingDialog; }
        protected getIdProperty() { return OrderProcessingRow.idProperty; }
        protected getInsertPermission() { return OrderProcessingRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderProcessingRow.localTextPrefix; }
        protected getService() { return OrderProcessingService.baseUrl; }
        private pendingChanges: Q.Dictionary<any> = {};
        public rowSelection: Serenity.GridRowSelectionMixin;

        public RateListId: number = 0;
        public LaborListId: number = 0;
        public StoneMarkup: number = 0;
        public LaborMarkup: number = 0;
        constructor(container: JQuery, param: number = 4) {
            super(container, param);
            var status = parseInt(param.toString());
            if (q.isNumber(status))
                (this.view.params as TransactionRequest).OrderStatusId = status;
            this.setTitle("");
        }

        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }
        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 100;
            return opt;
        }
        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            //columns.push(
            //    {
            //        field: 'Ship',
            //        name: 'Ship', 
            //        width: 90,
            //        minWidth: 90,
            //        maxWidth: 90
            //    });

            let shipColumn = Q.first(columns, x => x.field == "ShipOrder");

            shipColumn.format = ctx => {
                if (ctx.item.TypeDescription == "Ready to Ship")
                    return '<button class="inline-action add-button ship-order" href="#" style="background-color:#228B22;color:white;width:100%;height: 30px;"><span></span>Ship Order</button>';
                else if (ctx.item.TypeDescription == "In Stock")
                    return '<button class="inline-action add-button invoice-pending" href="#" style="background-color:#228B22;color:white;width:100%;height: 30px;"><span></span>Invoice Pending</button>';
                else if (ctx.item.TypeDescription == "Invoice Pending")
                    return '<button class="inline-action add-button invoice-pending" href="#" style="background-color:#228B22;color:white;width:100%;height: 30px;"><span></span>Invoice Pending</button>';
                else
                    return '';
            }
            let selectcolumn = Q.first(columns, x => x.field == "__select__");
            selectcolumn.width = 10;

            return columns;
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('ship-order')) {
                    var dialog = new Common.ShipperSelectDialog();
                    dialog.entity = item;


                    dialog.element.on('dialogclose', () => {

                        this.refresh();
                    });
                    dialog.dialogOpen();
                }
                if (target.hasClass('invoice-pending')) {
                    var salesdialog = new ECommSalesForOrderDialog();
                    var CompanyDetails = OMS.CompanyRow.getLookup().itemById[Q.Authorization.userDefinition.CompanyId];
                    if (CompanyDetails.IsPriceList) {
                        this.RateListId = CompanyDetails.SPriceListId || 0;
                        this.StoneMarkup = CompanyDetails.SMarkup || 0;
                    }

                    if (CompanyDetails.IsLabourList) {
                        this.LaborListId = CompanyDetails.SLabourListId || 0;
                        this.LaborMarkup = CompanyDetails.SLMarkup || 0;
                    }
                    let orderaddress;
                    var items = [];
                    var orderdetails = ECommOrderService.Retrieve({ EntityId: item.TransId },
                        response => {
                            orderaddress = response.Entity.AddressDetails
                        }, { async: false });
                    let stockitem;

                    Stock.StockItemService.GetOrderStock({
                        Line_No: item.Line_No,
                    },
                        response =>
                            stockitem = response.Entity,
                        { async: false }
                    );

                    items.push(stockitem);
                    var salesitems = ItemGridHelper.SetEcommerceInvoiceItem(items, item.ECommOrderItemId);
                    //salesitems[0].OrderAmount = item.GrossAmount;
                    salesitems[0].ECommOrderItemId = item.ECommOrderItemId;
                    let now = new Date();
                    var salesvoucher: ECommSalesRow = {
                        VoucherNo: FormatHelper.GetVoucherNo(87),

                        VoucherTypeId: 87,
                        CompanyId: Q.Authorization.userDefinition.CompanyId,
                        FinancialYearId: Q.Authorization.userDefinition.FinancialYearId,
                        UserId: Q.Authorization.userDefinition.UserId,
                        CurrencyId: Q.Authorization.userDefinition.CurrencyId,
                        POSCustomerId: item.PartyId,
                        CustomerName: item.CustomerName,
                        Mobile: item.Mobile,
                        Email: item.Email,
                        TransDate: now.toDateString(),
                        ItemDetails: salesitems,
                        AddressDetails: orderaddress,
                        ECommOrderNo: item.ECommOrderNo,
                        ECommOrderId: item.ECommOrderId,
                    }

                    salesdialog.loadEntityAndOpenDialog(salesvoucher, false);

                    salesdialog.element.on('dialogclose', () => {

                        this.refresh();
                    });
                    salesdialog.dialogOpen();
                }


                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }

        protected getButtons(): Serenity.ToolButton[] {
            var btns = super.getButtons();
            var _this = this;
            btns.pop();
            btns.push({
                title: "Allocate Stock",
                cssClass: "stock-button",
                hotkey: "alt+k",
                hint: 'alt+k',
                onClick: () => {

                    if (!this.onViewSubmit()) {
                        return;
                    }
                    let transitemids = [];
                    //  let _orderDetailsRows: OMSOrderItemRow[] = [];

                    if (this.rowSelection.getSelectedAsInt32().length > 0) {

                        var items = this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
                        for (var i = 0; i < items.length; i++) {
                            transitemids.push(items[i].TransItemId);
                        }
                        let orderitems;
                        ECommerce.ECommOrderItemsService.OrderProcessingList({ TransItemIds: transitemids }, response => { orderitems = response.Entities }, { async: false });
                        var stockallocationdialog = new Inventory.StockAllocationDialog();
                        let now = new Date();
                        let newitems = [];
                        for (var i = 0; i < orderitems.length; i++) {
                            var Item = orderitems[i];

                            var newitem: Inventory.StockAllocationItemsRow = {

                                ProductId: Item.ProductId,
                                AttributeId: Item.AttributeId,
                                Attribute: Item.Attribute,
                                Line_No: Item.Line_No == null ? Item.LineNo : Item.Line_No,
                                DepartmentId: Item.DepartmentId,
                                SKU: Item.SKU,
                                ProductCode: Item.ProductCode,
                                ProductName: Item.ProductName,
                                ItemTypeId: Item.ItemTypeId,
                                HasBom: Item.HasBom,
                                CategoryId: Item.CategoryId,
                                ProductTypeId: Item.ProductTypeId,
                                SubCategoryId: Item.SubCategoryId,
                                BrandId: Item.BrandId,
                                SuperTypeId: Item.SuperTypeId,
                                CollectionId: Item.CollectionId,
                                Pieces: Item.Pieces >= 0 ? Item.Pieces : 0,
                                Weight: Item.Weight,
                                OtherPieces: Item.OtherPieces,
                                OtherWeight: Item.OtherWeight,
                                StonePieces: Item.StonePieces,
                                StoneWeight: Item.StoneWeight,
                                NetWeight: Item.NetWeight,
                                DiamondPieces: Item.DiamondPieces,
                                DiamondWeight: Item.DiamondWeight,
                                CalcOnId: Item.CalcOnId,
                                BOMDetails: Item.BOMDetails,
                                // LaborDetails: labordetail,
                                CompanyId: Item.CompanyId,
                                HSN: Item.HSN,
                                TaxCode: Item.TaxCode,
                                MetalId: Item.MetalId,
                                KaratId: Item.ItemTypeId == 101 ? Item.KaratId : Item.KaratId,
                                MetalColorId: Item.MetalColorId,
                                QualityId: Item.QualityId,
                                SieveId: Item.SieveId,
                                ShapeId: Item.ShapeId,
                                StoneColorId: Item.StoneColorId,
                                StoneSizeId: Item.StoneSizeId,
                                ImageName: Item.ImageName,
                                Studded: Item.Studded, // marking item as bulk
                                StoneCutId: Item.StoneCutId,
                                StonePolishId: Item.StonePolishId,
                                StoneSymmetryId: Item.StoneSymmetryId,
                                StoneFluorescenceId: Item.StoneFluorescenceId,
                                StoneCuletId: Item.StoneCuletId,
                                StoneGirdleId: Item.StoneGirdleId,
                                StoneTable: Item.StoneTable,
                                StoneDepth: Item.StoneDepth,
                                Lab: Item.Lab,
                                CertificateNo: Item.CertificateNo,
                                Purity: Item.Purity,
                                CalcUnitId: Item.CalcUnitId,
                                LotNo: Item.LotNo,
                                PureWeight: Item.Weight * Item.Purity,
                                AllocatedItems: [],
                                RefVoucherId: 86,
                                RefTransId: Item.TransId,
                                RefTransItemId:Item.TransItemId
                            }
                            newitems.push(newitem);

                        }
                        var voucherNo = FormatHelper.GetVoucherNo(53);
                        var StockAllocationRow: Inventory.StockAllocationRow = {
                            VoucherNo: voucherNo,
                            CompanyId: Q.Authorization.userDefinition.CompanyId,
                            FinancialYearId: Q.Authorization.userDefinition.FinancialYearId,
                            VoucherTypeId: 79,
                            TransDate: now.toDateString(),
                            EmployeeId: Q.Authorization.userDefinition.UserId,
                            ItemDetails: newitems
                        };

                        stockallocationdialog.loadEntityAndOpenDialog(StockAllocationRow, false);
                        stockallocationdialog.element.on('dialogclose', () => {
                            this.refresh();
                        });
                    }
                    else {
                        q.Alert("No Data", "Select Items to Proceed", 2500, false);
                    }
                    return true;

                }

            });
            btns.push({
                title: "Create Purchase Order",
                cssClass: "stock-button",
                hotkey: "alt+k",
                hint: 'alt+k',
                onClick: () => {

                    if (!this.onViewSubmit()) {
                        return;
                    }
                    let transitemids = [];
                    //  let _orderDetailsRows: OMSOrderItemRow[] = [];
                    var items = this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
                    for (var i = 0; i < items.length; i++) {
                        transitemids.push(items[i].TransItemId);
                    }
                    let orderitems;
                    ECommerce.ECommOrderItemsService.OrderProcessingList({ TransItemIds: transitemids }, response => { orderitems = response.Entities }, { async: false });
                    var dialog = new Common.PartySelectDialog();
                    dialog.option = "Purchase Order";
                    dialog.entity = orderitems;
                    dialog.dialogOpen();
                }

            });
            btns.push({
                title: "Create Work Order",
                cssClass: "stock-button",
                hotkey: "alt+k",
                hint: 'alt+k',
                onClick: () => {
                    if (!this.onViewSubmit()) {
                        return;
                    }
                    let transitemids = [];
                    var items = this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
                    for (var i = 0; i < items.length; i++) {
                        transitemids.push(items[i].TransItemId);
                    }
                    let orderitems: ECommerce.ECommOrderItemsRow[];
                    ECommerce.ECommOrderItemsService.OrderProcessingList({ TransItemIds: transitemids }, response => { orderitems = response.Entities }, { async: false });

                    var details = [];
                    var workorderdialog = new Production.WorkOrderDialog();
                    let now = new Date();
                    var voucherNo = FormatHelper.GetVoucherNo(53);
                    var workorderitems: Production.WorkOrderItemsRow[];
                    orderitems.forEach(function (value: SalesOrder.SalesOrderItemsRow) {
                        var PrdId = value.ProductId;
                        var AtbId = value.AttributeId;
                        var bomdetails = [];
                        var labordetail = [];
                        var PrdDetails = value;


                        // #region Product Attributes
                        // **** Load & assign Attributes of Product using AtbID **** 
                        var oldbomdetails = value.BOMDetails;
                        for (var j = 0; j < oldbomdetails.length; j++) {
                            var oldbom = oldbomdetails[j];
                            var bom: Production.WorkOrderBOMRow = {
                                BomProductId: oldbom.BOMProductId,
                                AttributeId: oldbom.BOMAttributeId,
                                Pieces: oldbom.Pieces,
                                Weight: oldbom.Weight,
                                Line_No: value.Line_No,
                                Purity: oldbom.Purity == undefined ? 0 : oldbom.Purity,
                                PureWeight: oldbom.Purity * oldbom.Weight,
                                ProductId: oldbom.ProductId,
                                RefTransBomId: oldbom.TransBomId,
                                RefTransItemId: oldbom.TransItemId,
                                RefVoucherId: value.VoucherTypeId,
                                RefTransId: value.TransId,
                                CompanyId: value.CompanyId,
                            };
                            bomdetails.push(bom);
                        }
                        var purchase: Production.WorkOrderItemsRow = {
                            ProductId: PrdId,
                            ProductCode: PrdDetails.ProductCode,
                            AttributeId: AtbId,
                            Line_No: value.Line_No,
                            BagNo: value.BagNo,
                            Pieces: value.Pieces,
                            Weight: value.Weight,
                            Parts: value.Parts,
                            OtherPieces: value.OtherPieces,
                            OtherWeight: value.OtherWeight,
                            StonePieces: value.StonePieces,
                            StoneWeight: value.StoneWeight,
                            NetWeight: value.NetWeight,
                            DiamondPieces: value.DiamondPieces,
                            DiamondWeight: value.DiamondWeight,
                            RefTransId: value.TransId,
                            RefTransItemId: value.TransItemId,
                            RefVoucherId: value.VoucherTypeId,
                            DeliveryDate: value.DeliveryDate,
                            POSCustomerId: value.PartyId,
                            LedgerName: value.LedgerName,
                            RefVoucherNo: value.VoucherNo,
                            Purity: value.Purity,
                            PureWeight: value.PureWeight,
                            BOMDetails: bomdetails,
                            Attribute: value.Attribute
                        };

                        details.push(purchase);

                    });
                    var WorkOrderRow: Production.WorkOrderRow = {
                        VoucherNo: voucherNo,
                        CompanyId: Q.Authorization.userDefinition.CompanyId,
                        FinancialYearId: Q.Authorization.userDefinition.FinancialYearId,
                        UserId: Q.Authorization.userDefinition.UserId,
                        EmployeeId: Q.Authorization.userDefinition.UserId,
                        VoucherTypeId: 66,
                        TransDate: now.toDateString(),
                        SelectDetails: details
                    };

                    workorderdialog.loadEntityAndOpenDialog(WorkOrderRow, false);
                    workorderdialog.element.on('dialogclose', () => {
                        this.refresh();
                    });

                }

            });
            btns = btns.filter(x => x.cssClass != "add-button");

            btns.push(Serenity.ColumnPickerDialog.createToolButton(this as any));
            return btns;

        }
    }
}